import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function Nd1InsightCard({ post }) {
  const TagIcon = post.icon;

  return (
    <Link to={post.href} className="nd1-card nd1-insight-card">
      <div className="nd1-insight-card__media">
        {post.image ? <img src={post.image} alt={post.alt} loading="lazy" /> : null}
        <span className={`nd1-insight-card__tag nd1-insight-card__tag--${post.kind}`}>
          <TagIcon className="nd1-icon" aria-hidden="true" />
          {post.tag}
        </span>
        {post.duration ? (
          <span className="nd1-insight-card__duration">{post.duration}</span>
        ) : null}
      </div>
      <div className="nd1-insight-card__body">
        <h4 className="nd1-insight-card__title">{post.title}</h4>
        <p className="nd1-insight-card__copy">{post.copy}</p>
        <span className="nd1-insight-card__cta">
          {post.cta}
          <ArrowRight className="nd1-icon" aria-hidden="true" />
        </span>
      </div>
    </Link>
  );
}
